export default {
  PERMISSIONS ({ permissions }) {
    return permissions
  },
  PERMISSIONS_SIGNATURE ({ permissionsSignature }) {
    return permissionsSignature
  }
}
